import {
  IFileDescriptor,
  IUploadProgress,
  UploadErrorEvent,
} from '../../../api/mediaPlatform/types';
import { MediaSource, MediaType } from '../../../types/media';

enum UploadStatus {
  NEW = 'NEW',
  OK = 'OK',
  ERROR = 'ERROR',
}

type UploadErrorType = UploadErrorEvent | Error | string | any;

interface IUploadedMediaItem {
  source: MediaSource.UPLOAD;
  status: UploadStatus;
  name: string;
  originalName?: string;
  type: MediaType;
  url: string;
  selected?: boolean;
  previewImage?: string;
  progress?: IUploadProgress;
  descriptor?: IFileDescriptor;
  error?: UploadErrorType;
}

export { IUploadedMediaItem, UploadStatus, UploadErrorType };
